import React, { Component } from 'react';
import './ReviewButton.scss';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import ReviewModal from './ContactModal/ReviewModal';

class ReviewButton extends Component {
    constructor() {
        super();
        this.handleClose = this.handleClose.bind(this)
        this.handleOpen = this.handleOpen.bind(this)
    }

    state = {
        dialogOpen: false,
    };

    handleOpen() {
        this.setState({ dialogOpen: true });
    }

    handleClose() {
        this.setState({ dialogOpen: false });
    }

    render() {
        const { disabled, agreementId } = this.props;
        let { dialogOpen } = this.state;
        return (
            <Box>
                <Button disabled={disabled || !agreementId} variant="contained" size="small" color="secondary" onClick={this.handleOpen} >
                    <StarIcon />
                </Button>
                <ReviewModal
                    open={dialogOpen}
                    agreementid={agreementId}
                    onClose={this.handleClose}
                />
            </Box>
        );
    }
}


ReviewButton.propTypes = {
    agreementId: PropTypes.string,
    disabled: PropTypes.bool,
};

export default ReviewButton;
